import { RouteService } from '@/shared/services';
import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'nav-page-link',
  templateUrl: './nav-page-link.component.html',
  styleUrl: './nav-page-link.component.css',
  standalone: false,
})
export class NavPageLinkComponent {
  @Input() text: string = '';
  @Input() targetId: string = ''; // The ID of the section to scroll to
  @Input() tooltipMessage: string = '';

  env = environment;
  isHovering = false;

  constructor(private routeService: RouteService) {}

  scrollToSection() {
    if (!this.targetId) {
      console.warn('NavPageLinkComponent: targetId is not provided.');
      return;
    }
    const element = document.getElementById(this.targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      console.warn(
        `NavPageLinkComponent: Element with ID '${this.targetId}' not found.`,
      );
    }
  }
}
